import React from 'react'
import { TableCell, TableRow, Tooltip } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
function AuditListing({ item }) {

    return (
        <TableRow>
            <TableCell>{item?.action_type || '--'}</TableCell>
            <TableCell>{item?.created_at || '--'}</TableCell>
            <TableCell  style={{ color: item?.status === 'SUCCESS' ? '#210eaeff' : 'red', fontWeight: '600',minWidth:'110px' }}>{item?.status || '--'}</TableCell>
            <TableCell>{item?.folder_path || '--'}</TableCell>
            <TableCell >{item?.file_name || '--'}
                <Tooltip title={item?.file_path ? "Click to download" : ''}>
                    <GetAppIcon style={{ cursor: 'pointer', color: '#bd10e0', verticalAlign: "Bottom", color: '#bd10e0', fontSize: 'large', paddingLeft: '4px' }} onClick={(e) => item?.file_path ? window.open(decodeURIComponent(item.file_path), "_self") : e.preventDefault()} />
                </Tooltip>
            </TableCell>
            <TableCell>{item?.notified_emails || '--'}</TableCell>
        </TableRow>
    )
}

export default AuditListing